<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title" v-if="service.id > 0">
                Servis Güncelle
            </div>
            <div slot="title" v-if="service.id == 0">
                Servis Ekle
            </div>
            <div slot="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box">
                            <div class="box-body">
                                <div v-for="item in formMessages">
                                    <div class="alert" :class="'alert-' + item.type">
                                        {{ item.message }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>ID</label>
                                    <input type="text" class="form-control" v-model="service.sharedServiceId" :disabled="service.id > 0 ? 'disabled': null" />
                                </div>
                                <div class="form-group">
                                    <label>Adı</label>
                                    <input type="text" class="form-control" v-model="service.name" />
                                </div>
                                <div class="form-group">
                                    <label>Durumu</label>
                                    <div class="checkbox">
                                        <label><input type="checkbox" v-model="service.status" /> Aktif</label>
                                    </div>
                                </div>
                                <div class="form-actions">
                                    <button type="button" v-on:click="submit" :disabled="saving" class="btn btn-success">
                                        <span v-if="saving == false">Kaydet</span>
                                        <span v-if="saving">Lütfen bekleyiniz...</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from '../components/app_layout.vue';

export default {
    components: {
        'app-layout': AppLayout
    },
    data: function () {
        return {
            service: {
                id: 0,
                sharedServiceId: '',
                name: '',
                status: false
            },
            loading: true,
            saving: false,
            formMessages: []
        }
    },
    mounted: function () {
        var $this = this;
        var id = $this.$router.currentRoute.query.id;
        if (id > 0) {
            this.$app.get('/api/v1/services/' + id, function(xhr) {
                $this.loading = false;
                var response = xhr.responseJSON;
                $this.service = response.service;
            });
        } else {
            this.loading = false;
        }
    },
    methods: {
        submit: function () {
            var $this = this;
            this.saving = true;
            var params = {
                id: this.service.id,
                shared_service_id: this.service.sharedServiceId,
                name: this.service.name,
                status: this.service.status ? 1 : 0
            };
            this.$app.post('/api/v1/services', params, function (xhr) {
                var data = xhr.responseJSON;
                if (data.formMessages != undefined) {
                    $this.formMessages = data.formMessages;
                }
                if (data.meta.httpStatusCode == 200) {

                } else if (data.meta.httpStatusCode == 201) {
                    $this.service = {
                        id: 0,
                        sharedServiceId: '',
                        name: '',
                        status: false
                    };
                }
                $this.saving = false;
                window.scrollTo(0, 0);
            });
        }
    },
    watch: {
        '$route': function () {
            if (this.$router.currentRoute.query.id == undefined) {
                this.service = {
                    id: 0,
                    sharedServiceId: '',
                    name: '',
                    status: false
                };
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// service_save.vue?7c2742fb